import { CAT_NECESSARY, CAT_ANALYTICS } from "../constants";

const translation = {
  consentModal: {
    title: "ਕੂਕੀ ਸੂਚਨਾ",
    description:
      "ਅਸੀਂ ਇਸ ਵੈੱਬਸਾਈਟ ਨੂੰ ਠੀਕ ਤਰੀਕੇ ਨਾਲ ਚਲਾਉਣ ਲਈ ਲਾਜ਼ਮੀ ਕੂਕੀ ਵਰਤਦੇ ਹਾਂ। ਅਸੀਂ ਵਿਕਲਪਿਕ ਟਰੈਕਿੰਗ ਕੂਕੀ ਵੀ ਵਰਤਦੇ ਹਾਂ ਤਾਂ ਕਿ ਅਸੀਂ ਸਮਝ ਸਕੀਏ ਕਿ ਤੁਸੀਂ ਸਾਡੀ ਵੈੱਬਸਾਈਟ ਨਾਲ ਕਿਵੇਂ ਇੰਟਰਐਕਟ ਕਰਦੇ ਹੋ। ਇਹ ਵਿਕਲਪਿਕ ਕੂਕੀ ਤੁਹਾਡੀ ਮਨਜ਼ੂਰੀ ਨਾਲ ਹੀ ਸੈੱਟ ਕੀਤੀਆਂ ਜਾਣਗੀਆਂ।",
    acceptAllBtn: "ਸਭ ਮਨਜ਼ੂਰ ਕਰੋ",
    acceptNecessaryBtn: "ਸਭ ਰੱਦ ਕਰੋ",
    showPreferencesBtn: "ਵਿਅਕਤੀਗਤ ਪਸੰਦਾਂ ਸੰਭਾਲੋ",
  },
  preferencesModal: {
    title: "ਕੂਕੀ ਪਸੰਦਾਂ ਸੰਭਾਲੋ",
    acceptAllBtn: "ਸਭ ਮਨਜ਼ੂਰ ਕਰੋ",
    acceptNecessaryBtn: "ਸਭ ਰੱਦ ਕਰੋ",
    savePreferencesBtn: "ਮੌਜੂਦਾ ਚੋਣ ਮਨਜ਼ੂਰ ਕਰੋ",
    closeIconLabel: "ਵਿੰਡੋ ਬੰਦ ਕਰੋ",
    sections: [
      {
        title: "ਕੂਕੀ ਦੀ ਵਰਤੋਂ",
        description: "ਅਸੀਂ ਵੈੱਬਸਾਈਟ ਦੇ ਮੂਲ ਕੰਮਾਂ ਦੀ ਸਹਾਇਤਾ ਅਤੇ ਤੁਹਾਡੇ ਬ੍ਰਾਊਜ਼ਿੰਗ ਅਨੁਭਵ ਨੂੰ ਸੁਧਾਰਨ ਲਈ ਕੂਕੀਜ਼ ਵਰਤਦੇ ਹਾਂ।",
      },
      {
        title: "ਕੜਕ ਲੋੜੀਂਦੀਆਂ ਕੂਕੀਜ਼",
        description: "ਇਹ ਕੂਕੀਜ਼ ਵੈੱਬਸਾਈਟ ਦੇ ਸਹੀ ਤਰੀਕੇ ਨਾਲ ਕੰਮ ਕਰਨ ਲਈ ਲਾਜ਼ਮੀ ਹਨ, ਉਦਾਹਰਣ ਵਜੋਂ ਯੂਜ਼ਰ ਦੀ ਪਛਾਣ ਲਈ।",
        linkedCategory: CAT_NECESSARY,
        cookieTable: {
          headers: { name: "ਨਾਂ", domain: "ਸੇਵਾ", description: "ਵੇਰਵਾ", expiration: "ਮਿਆਦ" },
          body: [
            {
              name: "_care_leavers_social_hub_session",
              domain: "www.secure-messaging.co.uk",
              description: "ਕੂਕੀ ਡਿਜੀਟਲ ਕਮੇਊਨਿਟੀ ਪਲੇਟਫਾਰਮ ਵੱਲੋਂ ਯੂਜ਼ਰ ਦੀ ਪਛਾਣ ਲਈ ਸੈੱਟ ਕੀਤੀ ਗਈ।",
              expiration: "ਸੈਸ਼ਨ",
            },
            {
              name: "CSRF-TOKEN",
              domain: "www.secure-messaging.co.uk",
              description: "ਕੂਕੀ ਡਿਜੀਟਲ ਕਮੇਊਨਿਟੀ ਪਲੇਟਫਾਰਮ ਵੱਲੋਂ ਯੂਜ਼ਰ ਦੀ ਪਛਾਣ ਲਈ ਸੈੱਟ ਕੀਤੀ ਗਈ।",
              expiration: "ਸੈਸ਼ਨ",
            },
            {
              name: "__cf_bm",
              domain: ".www.secure-messaging.co.uk",
              description:
                "ਇਹ ਕੂਕੀ ਮਨੁੱਖ ਅਤੇ ਰੋਬੋਟ ਵਿਚ ਫਰਕ ਕਰਨ ਲਈ ਵਰਤੀ ਜਾਂਦੀ ਹੈ ਅਤੇ ਵੈਬਸਾਈਟ ਨੂੰ ਕੁਝ ਬਦਤਮਿਜ਼ ਵਰਤੋਂ ਤੋਂ ਬਚਾਉਂਦੀ ਹੈ। ਕੋਈ ਵੀ ਨਿੱਜੀ ਜਾਣਕਾਰੀ ਇਕੱਤਰ ਨਹੀਂ ਕੀਤੀ ਜਾਂਦੀ।",
              expiration: "30 ਮਿੰਟ",
            },
          ],
        },
      },
      {
        title: "ਵਿਸ਼ਲੇਸ਼ਣ",
        description:
          "ਵਿਸ਼ਲੇਸ਼ਣ ਲਈ ਵਰਤੀਆਂ ਜਾਣ ਵਾਲੀਆਂ ਕੂਕੀਜ਼ ਡਾਟਾ ਇਕੱਤਰ ਕਰਨ ਵਿੱਚ ਮਦਦ ਕਰਦੀਆਂ ਹਨ ਜੋ ਸੇਵਾਵਾਂ ਨੂੰ ਸਮਝਣ ਦੀ ਆਗਿਆ ਦਿੰਦੀਆਂ ਹਨ ਕਿ ਯੂਜ਼ਰ ਕਿਸ ਤਰ੍ਹਾਂ ਕਿਸੇ ਖਾਸ ਸੇਵਾ ਨਾਲ ਇੰਟਰਐਕਟ ਕਰਦੇ ਹਨ। ਇਹ ਆਲੋਚਨਾਵਾਂ ਸਮੱਗਰੀ ਵਿੱਚ ਸੁਧਾਰ ਅਤੇ ਬਿਹਤਰ ਵਿਸ਼ੇਸ਼ਤਾਵਾਂ ਡਿਜ਼ਾਈਨ ਕਰਨ ਵਿੱਚ ਮਦਦ ਕਰਦੀਆਂ ਹਨ ਜੋ ਯੂਜ਼ਰ ਦੇ ਤਜਰਬੇ ਨੂੰ ਬਹਿਤਰ ਬਣਾਉਂਦੀਆਂ ਹਨ।",
        linkedCategory: CAT_ANALYTICS,
        cookieTable: {
          headers: { name: "ਨਾਂ", domain: "ਸੇਵਾ", description: "ਵੇਰਵਾ", expiration: "ਮਿਆਦ" },
          body: [
            {
              name: "_ga",
              domain: "Google Analytics",
              description:
                'ਕੂਕੀ <a href="https://business.safety.google/adscookies/">Google Analytics</a> ਵੱਲੋਂ ਸੈੱਟ ਕੀਤੀ ਗਈ',
              expiration: "12 ਦਿਨਾਂ ਬਾਅਦ ਮਿਆਦ ਖਤਮ",
            },
            {
              name: "_gid",
              domain: "Google Analytics",
              description:
                'ਕੂਕੀ <a href="https://business.safety.google/adscookies/">Google Analytics</a> ਵੱਲੋਂ ਸੈੱਟ ਕੀਤੀ ਗਈ',
              expiration: "ਸੈਸ਼ਨ",
            },
          ],
        },
      },
    ],
  },
};

const servicesLabel = "ਵਿਸ਼ਲੇਸ਼ਣ ਨਾਲ ਸਬੰਧਤ ਸਟੋਰੇਜ਼ ਯੋਗ ਬਣਾਉਂਦਾ ਹੈ, ਜਿਵੇਂ ਕਿ ਦੌਰੇ ਦਾ ਸਮਾਂ।";

export { translation, servicesLabel };
